import { Component, OnInit, Input } from '@angular/core';
// import { FormConfig } from '@ptl/forms';
import { FormComponentLookup, FormNavigationConfig, DefaultFormConfig } from '@ptl/forms';
import { FormPageComponentClass } from '@ptl/forms';
import { FormConfig } from '@ptl/forms';
import { PagePreauthorizationService } from './page-preauthorization.service';


@FormComponentLookup('page-preauthorization')
@Component({
    selector: 'app-page-preauthorization',
    templateUrl: './page-preauthorization.component.html',
    styleUrls: ['./page-preauthorization.component.scss'],
    standalone: false
})

export class PagePreauthorizationComponent extends FormPageComponentClass<FormNavigationConfig> implements OnInit {

  constructor(private preauthService: PagePreauthorizationService) {
    super();
  }

  ngOnInit() {
    this.initPageConfig();

    if (this.formConfig.form.customConfigs?.ageCheckConfig) {
      this.preauthService.configureAgeCheck(
        this.formConfig.form.customConfigs?.ageCheckConfig,
        this.subscriptionGroup,
        this.pageFormGroups,
        this.formStreamTrigger
      );
    }
  }

  submitHook(formConfig): Promise<any> {
    return new Promise((resolve, reject) => {
      this.preauthService.saveMedigapDataToState(this.formConfig);
      resolve(true);
    });
  }
}
